import http from "../../utils/http";

export const getCompaniesSchedules = (managerCompanyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/dashboard/${managerCompanyIdx}/schedule/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagementSummary = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/summary`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagementPaymentList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/payment/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxCompaniesInfo = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/dashboard/companies`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagementList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagement = (managementIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/management/${managementIdx}`)
      .then((res) => {
        resolve(res.data?.management);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagementGroupList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/group/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addManagementGroup = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/management/group", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editManagementGroup = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/management/group/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteManagementGroups = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/management/group`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addMappingManagementGroup = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/group/mapping`, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteMappingManagementGroup = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/management/group/mapping`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMappingManagementDownloadExcel = () => {
  return new Promise((resolve, reject) => {
    http
      .post("/management/excel/download", {}, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

};

export const addManagement = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/management", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editManagement = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/management/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};